import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "width-wrap" }
const _hoisted_2 = { class: "estate-detail__params" }
const _hoisted_3 = {
  key: 0,
  class: "estate-param estate-detail__price"
}
const _hoisted_4 = { class: "price-per-month" }
const _hoisted_5 = {
  key: 0,
  class: "price-square"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_7 = {
  key: 0,
  class: "estate-detail__interested"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdParams = _resolveComponent("AdParams")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isDeveloperProject)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(["price", _ctx.priceClass])
              }, [
                (_ctx.ad.price)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.ad.price, _ctx.ad.currency)) + " ", 1),
                      _createElementVNode("span", _hoisted_4, [
                        (_ctx.isLease)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('AdDetailHeader.price-per-month-lease')), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.isRoommate)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('AdDetailHeader.price-per-month-roommate')), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.ad.pricePerSquareMeter)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                            _createTextVNode("(" + _toDisplayString(_ctx.$filters.currency(_ctx.ad.pricePerSquareMeter, _ctx.ad.currency)) + "/m", 1),
                            _hoisted_6,
                            _createTextVNode(")")
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t(_ctx.isEstateAgency ? 'price.empty-agency' : 'price.empty')), 1)
                    ], 64))
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showParams)
          ? (_openBlock(), _createBlock(_component_AdParams, {
              key: 1,
              ad: _ctx.ad
            }, null, 8, ["ad"]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isPreview && !_ctx.showParams)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "button button--primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInterested && _ctx.onInterested(...args)))
            }, _toDisplayString(_ctx.$t('AdDetailHeader.button-interested')), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}